import { select, call } from "redux-saga/effects";
import { deconstructSchoolID, deconstructStudentID } from "lib/appserver/aggregate";
import { getMobileNumber, getDeviceToken } from "state/app/selectors";
import { sendSchoolMoneyDataRequest } from "state/fetchSagas";
import { getCheckoutTransactionID, getCheckoutSchoolID, getSecureTradingPSD2ErrorCode, getSecureTradingPSD2ErrorMessage, getStudentsHavingBasketItems } from "state/school_money/selectors";

// Saga to handle save audit action
export default function* saveAuditSaga(action) {
  const schoolID = yield select(getCheckoutSchoolID);
  const studentID = yield select(getStudentsHavingBasketItems, schoolID);
  const { serverID, remoteSchoolID } = deconstructSchoolID(schoolID);
  const { remoteStudentID } = deconstructStudentID(studentID.toList().get(0));
  const googlePayLogMobileNumbers = ["+447970266062", "+447808768954", "+447448548748"];

  if(getAuditTitle(action.payload.type) === "Siva DEBUG" && !googlePayLogMobileNumbers.includes(yield select(getMobileNumber))) {
      return;
  }

  try {
      yield call(sendSchoolMoneyDataRequest, "save_audit_log", {
        server_id: serverID,
        remote_school_id: remoteSchoolID,
        mobile_number: yield select(getMobileNumber),
        device_token: yield select(getDeviceToken),
        type: getAuditTitle(action.payload.type),
        detail: yield getAuditDetail(action.payload.type),
        student_fk: remoteStudentID
    });
  } catch (error) {
      console.log("Failed to add logs");
  }
}

function getAuditTitle(auditType) {
    switch (auditType) {
      case "ST_CARD_DETAILS_TOKEN_GENERATED": return "Card Details Token Generated";
      case "ST_APPLE_PAY_TOKEN_GENERATED": return "Apple Pay Token Generated";
      case "ST_GOOGLE_PAY_TOKEN_GENERATED": return "Google Pay Token Generated";
      case "ST_PAYMENT_RESPONSE": return "ST Payment Response";
      case "PAYMENT_PROCESS_STARTED": return "Payment Process started";
      case "PAYMENT_SUCCESS": return "Payment Successfully Completed";
      case "PAYMENT_FAILED": return "Payment failed";
      case "GOOGLE_PAY_PAYMENT_PROCESS_STARTED": return "Google pay process started";
      default: return "Siva DEBUG";
    }
}

function* getAuditDetail(auditType) {
    const transactionID = yield select(getCheckoutTransactionID);
    const errorCode = yield select(getSecureTradingPSD2ErrorCode);
    const errorMessage = yield select(getSecureTradingPSD2ErrorMessage);
    switch (auditType) {
      case "ST_CARD_DETAILS_TOKEN_GENERATED": return "Secure Trading card payment token has been generated - order reference: " + transactionID + ".";
      case "ST_APPLE_PAY_TOKEN_GENERATED": return "Secure Trading Apple payment token has been generated - order reference: " + transactionID + ".";
      case "ST_GOOGLE_PAY_TOKEN_GENERATED": return "Secure Trading Google payment token has been generated - order reference: " + transactionID + ".";
      case "ST_PAYMENT_RESPONSE": return "Payment response received from SecureTrading for order reference: " + transactionID + " - Error Code: " + errorCode + " and Error Message: " + errorMessage + ".";
      case "PAYMENT_PROCESS_STARTED": return "Payment process has been initialised - order reference: " + transactionID + ".";
      case "PAYMENT_SUCCESS": return "Secure Trading payment has been successfully completed - order reference: " + transactionID + ".";
      case "PAYMENT_FAILED": return "There was an issue with SecureTrading payment for order reference: " + transactionID + ".";
      case "GOOGLE_PAY_PAYMENT_PROCESS_STARTED": return "Google pay payment process has been initialised - order reference: " + transactionID + "."
      default: return auditType;
    }
}



// WEBPACK FOOTER //
// ./src/state/school_money/sagas/saveAudit.js